import {Snackbar, Alert} from '@mui/material';
import {useEffect, useRef} from 'react';
import {useAnalytics} from '../../../hooks/useAnalytics';
import {GAErrorInfo, GAToastTrackingInfo} from '../../../types/analyticsTypes';
import {
  GA_DATA_MODE_AUTO,
  GA_EVENT_NAMES,
} from '../../../constants/analyticsConstants';

const HDIE_DURATION = 6000;

type ToastProps = {
  open: boolean;
  message: string;
  severity?: 'success' | 'warning' | 'error';
  hideDuration?: number;
  onClose: () => void;
  ariaLabel?: string;
  horizontalPosition?: 'center' | 'left' | 'right';
  verticalPosition?: 'bottom' | 'top';
  gaTrackingInfo?: GAToastTrackingInfo;
};

const bgColorMap: Map<string, string> = new Map();
bgColorMap.set('success', 'aur-toast-success-style');
bgColorMap.set('warning', 'aur-toast-warning-style');
bgColorMap.set('error', 'aur-toast-error-style');

const AurToast = ({
  open,
  message,
  severity = 'success',
  hideDuration = HDIE_DURATION,
  onClose,
  ariaLabel,
  horizontalPosition = 'right',
  verticalPosition = 'bottom',
  gaTrackingInfo,
}: ToastProps) => {
  const {trackGAEvent} = useAnalytics();

  const prevOpenRef = useRef(open);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      prevOpenRef.current = open;
      return;
    }

    if (!prevOpenRef.current && open) {
      if (severity === 'error') {
        if (!gaTrackingInfo?.dontTrack) {
          const error: GAErrorInfo = {
            text: message,
          };
          if (gaTrackingInfo?.code) {
            error.code = gaTrackingInfo.code;
          }
          if (gaTrackingInfo?.type) {
            error.type = gaTrackingInfo.type;
          }
          trackGAEvent({
            eventName: GA_EVENT_NAMES.ERROR,
            page: GA_DATA_MODE_AUTO,
            user: GA_DATA_MODE_AUTO,
            error: error,
          });
        }
      }
    }

    prevOpenRef.current = open;
  }, [open]);
  return (
    <Snackbar
      open={open}
      autoHideDuration={hideDuration}
      onClose={onClose}
      anchorOrigin={{
        vertical: verticalPosition,
        horizontal: horizontalPosition,
      }}
      aria-label={ariaLabel}
      className={`aur-toast-parent-div ${verticalPosition}`}
      sx={{right: horizontalPosition === 'right' ? '22vw !important' : ''}}
      id="aur-toast"
      tabIndex={0}
    >
      <Alert
        severity={severity}
        variant="filled"
        className={`typo-text label1_size toastMessageText_size aur-toast-body ${bgColorMap.get(severity)}`}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AurToast;
